export default "__VITE_ASSET__BKf9Orqr__"